// extracted by mini-css-extract-plugin
module.exports = {"root":"Images45_root__1jRPj","title":"Images45_title__1_Swr","images":"Images45_images__2c_uV"};